import LocationSelect from '@/components/location-select/index.vue';
import Service from '@/service/index.js';
import PublishProjectService from '../../publish-purchase-service.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    LocationSelect
  },
  props: ['projectInfo'],
  data() {
    return {
      areaCode: '',
      length: 0,
      purchaseProjectType: [], // 项目类型
      purchaseCateGory: [], // 项目分类
      projectCategoryValueFlag: false,
      goodsTypeArr: [],
      ruleForm: {
        projectType: 1,
        projectName: '',
        projectNameInit: '',
        projectCategory: [],
        projectCategoryValue: '',
        city: '',
        county: '',
        township: '',
        village: '',
        goodsType: 2
      },
      rules: {
        projectNameInit: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        projectCategory: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        projectCategoryValue: [
          { required: true, message: '请输入项目分类', trigger: 'blur' }
        ],
        goodsType: [
          { required: true, message: '请选择货物类型', trigger: 'change' }
        ],
        village: [
          { required: true, message: '请选择完整的坐落位置', trigger: 'change' }
        ]
      },
      cityList: [],
      districtList: [],
      townList: [],
      villageList: [],
      address: '',
      isInit: true
    };
  },
  watch: {
    'ruleForm.projectType': {
      handler: function (value) {
        this.ruleForm.goodsType = 2;
        this.$store.commit('UPDATE_PURCHASE_TYPE', '');
        this.$store.commit('UPDATE_PROJECT_TYPE_PUR', value);
        this.$store.dispatch('updatePurchaseProcessList', { projectType: value, purchaseType: '' });
      },
      immediate: true
    },
    'ruleForm.goodsType': function (value) {
      if (value) {
        this.$store.commit('UPDATE_GOODS_TYPE', value);
      }
    },
    'ruleForm.projectCategory': function (list) {
      if (list.includes(11)) {
        this.projectCategoryValueFlag = true;
        this.$set(this.rules.projectCategoryValue, 0, { required: true, message: '请输入项目分类', trigger: 'blur' });
      } else {
        this.projectCategoryValueFlag = false;
        this.$set(this.rules.projectCategoryValue, 0, { required: false, message: '请输入项目分类', trigger: 'blur' });
      }
    },
    projectInfo: 'projectInit'
  },
  computed: {
    purchaseCateGoryList() {
      if(this.ruleForm.projectType === 1) {
        return this.purchaseCateGory.filter(v =>  {
          return v.code !==9 && v.code !==10;
        });
      } else if (this.ruleForm.projectType === 2) {
        return this.purchaseCateGory.filter(v => {
          return v.code !==2 && v.code !==4 && v.code !== 6 && v.code !== 8 && v.code !== 10;
        });
      } else {
        return this.purchaseCateGory.filter(v => {
          return v.code !==2 && v.code !==4 && v.code !== 6 && v.code !== 8 && v.code !== 10;
        });
      }
    },
    ...mapGetters(['getTenantParams'])
  },
  created () {
    this.$store.commit('UPDATE_GOODS_TYPE', 2);
    this.getDictionarySelect();
  },
  mounted() {
    // this.getcityInfo();
  },
  methods: {
    projectInit() {
      Object.keys(this.ruleForm).forEach((key) => {
        if (this.projectInfo[key]) {
          this.ruleForm[key] = this.projectInfo[key];
          if(key === 'projectName') {
            this.address = this.projectInfo.address.split(' ')[1]+this.projectInfo.address.split(' ')[2]+this.projectInfo.address.split(' ')[3]+this.projectInfo.address.split(' ')[4];
            var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
            var replaceStr = this.projectInfo.projectName.replace(regexp, '');
            this.ruleForm.projectNameInit = replaceStr; // 输入input的value
            console.log(this.address, this.ruleForm.projectNameInit);
          }
        }
      });
      if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.isInit = true;
      }
      if(!this.isInit) {
        setTimeout(() => {
          this.areaCode = this.ruleForm.village;
        }, 500);
      } else {
        console.log(this.isInit, 'this.isInit', this.ruleForm.village);
        this.areaCode = this.ruleForm.village;
        this.isInit = false;
      }
      // 项目分类回显
      if(this.projectInfo && this.projectInfo.projectCategory) {
        let projectCategoryList = this.projectInfo.projectCategory;
        let _projectCategory = [];
        projectCategoryList && projectCategoryList.map(item => {
          _projectCategory.push(item.projectCategory);
        });
        this.ruleForm.projectCategory = _projectCategory;
      }
    },
    updateProjectType() {
      this.$store.commit('UPDATE_PROJECT_TYPE_PUR', this.ruleForm.projectType);
      this.areaCode = this.getTenantParams.areaCode;
      this.ruleForm.village = '';
      this.ruleForm.city = '';
      this.ruleForm.county = '';
      this.ruleForm.township = '';
      this.address = '';
      this.$refs['basicForm'].resetFields();
      if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.projectInit();
      }
      //  else {
      //   this.getcityInfo();
      // }
    },
    // 获取注册时候位置信息
    getcityInfo() {
      PublishProjectService.getUserBaseInfo().then(res => {
        if(res && res.code === '0') {
          if(this.areaCode === res.data.county) {
            this.areaCode = res.data.village;
            this.address = res.data.addressDetail.split(' ')[1]+res.data.addressDetail.split(' ')[2]+res.data.addressDetail.split(' ')[3]+res.data.addressDetail.split(' ')[4];
            if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
              if( this.projectInfo.projectName ) {
                var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
                var replaceStr = this.projectInfo.projectName.replace(regexp, '');
                this.ruleForm.projectNameInit = replaceStr; // 输入input的value
              }
            }
          }
        }
      });
    },
    // 获取字典项
    getDictionarySelect() {
      const arr = [
        ['purchaseProjectType', 'PURCHASE_PROJECT_TYPE'], // 项目类型
        ['purchaseCateGory', 'PURCHASE_CATEGORY'] // 项目分类
        // ['goodsTypeArr', 'PURCHASE_GOODS_TYPE']   // 货物类型
      ];
      arr.forEach((value) => {
        if (!value.length) {
          return;
        }
        Service.getSelectList(value[1]).then(res => {
          if (res && res.code === '0') {
            res.data.forEach(v => { v.code = Number(v.code);});
            this[value[0]] = res.data;
            if(this.getTenantParams.citytitle === '颍上县') {
              this.purchaseProjectType = this.purchaseProjectType.filter(v => Number(v.code) !== 4);
            }
          }
        });
      });
    },
    areaCodeChange(event) {
      let levelArr = ['city', 'county', 'township', 'village'];
      const levelIndex = levelArr.findIndex(v => v === event.type);
      levelArr.forEach((v, index) => {
        if (index > levelIndex) {
          this.ruleForm[v] = '';
        }
      });
      const key = event && event.type;
      this.ruleForm[key] = event.areaCode;
      this.areaCode = event.areaCode;
      setTimeout(() => {
        const childRef = this.$refs['locationSelect'] && this.$refs['locationSelect'].$refs;
        const address = Object.keys(childRef).reduce((current, item) => {
          return current += childRef[item].selectedLabel;
        }, '');
        if (!new RegExp('[0-9]').test(address)) {
          this.address = address;
        }
        this.length = 50 - this.address.trim().length;
      }, 500);
    },
    test() {
      if (this.ruleForm.projectCategory === '11') {
        this.rules.projectCategoryValue = [
          { required: true, message: '请输入项目分类', trigger: 'blur' }
        ];
      }
      // 重新选择项目位置的基础下
      this.ruleForm.projectName = (this.address + this.ruleForm.projectNameInit).replace(/\s+/g, ''); // 需要传给后台的projectName
      return new Promise((resolve, reject) => {
        this.$refs['basicForm'].validate((valid) => {
          if (valid) {

            // 项目分类
            let projectCategoryList = [];
            this.purchaseCateGory.map(item => {
              if(this.ruleForm.projectCategory.includes(item.code)) {
                projectCategoryList.push({
                  projectCategory: item.code,
                  projectCategoryValue: item.value
                });
              }
            });
            resolve(JSON.parse(JSON.stringify({
              ...this.ruleForm,
              projectCategory: projectCategoryList
            })));
          } else {
            reject();
          }
        });
      });
    }
  }
};
